module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0179.jpg?v=db8326f8";